import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBorderMot } from "@EUForms/selectors";
import { validateTerminalUsingMot } from "../../util";


const  TerminalDetail=({isImportShipment, saveData,updateData,renderForm})=>{

    const mot=useSelector(selectBorderMot)
    const disable=validateTerminalUsingMot(mot,isImportShipment)
    const terminal = useSelector((state) => state.transportReducer.terminal);
    const dispatch=useDispatch()

   const onSelect=useCallback((e, {value,name})=>{
          dispatch(updateData({[name]:value?.trim()}))
           saveData({[name]:value})
           ,[updateData,saveData]
   },[updateData,saveData])
   
  return(
     renderForm && renderForm({disable,onSelect,terminal})
  )
}
export default React.memo(TerminalDetail)